import { IConfigurationOption } from 'models'

export const ssoApplicationsSubOptions: IConfigurationOption[] = [
    {
        name: 'all',
        title: 'All',
        route: '/all',
        requireAccess: {
            page: 'MyIdentity-SSOApplications-All-Page',
        },
    },
    {
        name: 'recentlyUsed',
        title: 'RecentlyUsed',
        route: '/recentlyUsed',
        requireAccess: {
            page: 'MyIdentity-SSOApplications-RecentlyUsed-Page',
        },
    },
]
